/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function CeldaEditable(e) {
  let t = (0, ReactCompiler.c)(17),
    { inicial: n, desdeTecla: r, etiqueta: i, onTerminar: a } = e,
    [o, s] = (0, React.useState)(n),
    c = (0, React.useRef)(null),
    l = (0, React.useRef)(!1),
    u;
  t[0] === a
    ? (u = t[1])
    : ((u = (...e) => {
        let t = e;
        l.current || ((l.current = !0), a(...t));
      }),
      (t[0] = a),
      (t[1] = u));
  let f = u,
    p,
    m;
  (t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((p = () => {
        let e = c.current;
        e && (e.focus(), e.setSelectionRange(e.value.length, e.value.length));
      }),
      (m = []),
      (t[2] = p),
      (t[3] = m))
    : ((p = t[2]), (m = t[3])),
    (0, React.useEffect)(p, m));
  let h;
  t[4] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((h = (e) => s(e.target.value)), (t[4] = h))
    : (h = t[4]);
  let _;
  t[5] !== f || t[6] !== o
    ? ((_ = () => f(o)), (t[5] = f), (t[6] = o), (t[7] = _))
    : (_ = t[7]);
  let v;
  t[8] !== r || t[9] !== f || t[10] !== o
    ? ((v = (e) => {
        (e.stopPropagation(),
          e.key === `Enter` || e.key === `Tab`
            ? (e.preventDefault(), f(o, e.key, e.shiftKey))
            : e.key === `Escape`
              ? (e.preventDefault(), f(void 0))
              : r &&
                e.key.startsWith(`Arrow`) &&
                (e.preventDefault(), f(o, e.key)));
      }),
      (t[8] = r),
      (t[9] = f),
      (t[10] = o),
      (t[11] = v))
    : (v = t[11]);
  let y;
  return (
    t[12] !== i || t[13] !== _ || t[14] !== v || t[15] !== o
      ? ((y = (
          <input
            ref={c}
            aria-label={i}
            value={o}
            maxLength={200}
            onChange={h}
            onBlur={_}
            onKeyDown={v}
            className={`h-full w-full bg-(--bg) px-0 text-xs text-(--text-h) uppercase outline-none`}
          />
        )),
        (t[12] = i),
        (t[13] = _),
        (t[14] = v),
        (t[15] = o),
        (t[16] = y))
      : (y = t[16]),
    y
  );
}
